import Layout from '../calc/Layout.js'
let text = window.text; // We depend on global localization


class Lay {

  constructor() {
      this.types = {};
      this.names = [];
      this.utstickTypes = {};
      this.utstickNames = [];
      this.plates = [];
      this.families = {};
  }

  register(name, obj) {
    this.types[name] = obj
    this.names.push(name)
  }

  registerUtstick(name, obj) {
    this.utstickTypes[name] = obj
    this.utstickNames.push(name)
  }

  get(name) {
    return new this.types[type]()
  }

  getUtstick(name) {
    return new this.types[type]()
  }

  // Add a type of plate that the user should be able to choose from
  addplate(plate) {
    if(plate.surface == undefined)
      plate.surface = text.def
    this.plates.push(plate)
    if(this.families[plate.family] == undefined)
      this.families[plate.family] = []
    this.families[plate.family].push(plate)
    this.families[plate.family].sort()
  }

  // Optimize a roof of a specific type, described by the roof and
  // using plates described by plate
  //optimize(type, roof, plate) {
  optimize(roofs, plate) {
    let pl = {
  		width: 1000*plate.width,
  		horizontalOffset: 1000*plate.horizontalOffset,
  		verticalOffset: 1000*plate.verticalOffset,
  		rotate: plate.rotate,
  	}
    if(plate.height.type===undefined) {
      pl.height = 1000*plate.height
    } else if(plate.height.type == "variable"){
      pl.height = {
        type: "variable",
        min: 1000*plate.height.min,
        max: 1000*plate.height.max,
      }
    } else if(plate.height.type == "stepwise"){
      pl.height = {
        type: "stepwise",
        height: plate.height.height.map(h => 1000*h),
      }
    }

    // Append patches from all roofs and utsticks
    let ps = [];
    let trans = [];
    let psroofs = [];
    let types = [];
    let categories = [];
		let pipes = [];
    let mone = 0
    let vindski = 0
    let gradeGutter = 0
    for (let i = 0; i < roofs.length; i++){
      let type = roofs[i].type;
      let roof = roofs[i].roof;
      let o;
      if(this.types[type] !== undefined){
        o = new this.types[type](roof, plate);
      } else if (this.utstickTypes[type] !== undefined) {
        o = new this.utstickTypes[type](roof, plate);
        gradeGutter += o.gradeGutter()*1
      }else{
        throw "using a roof type that has not been registered";
      }

      Array.prototype.push.apply(ps, o.topatches());
      Array.prototype.push.apply(trans, o.patchtransforms());
      psroofs.push(o);
      types.push(roofs[i].type);
      categories.push(roofs[i].category);
			for(let i = 0; i<o.pipes().length; i++) {
			  pipes.push(o.pipes()[i])
      }

      vindski += o.vindski()*1
      mone += o.mone()*1
    }

    let lo = new Layout();
    lo.setPlate(pl);
    let sol = lo.layout(ps);
    sol.noPatches = ps.length;
    sol.patches = ps;
    sol.transforms = trans;
    sol.roofs = psroofs;
    sol.types = types;
    sol.categories = categories;
    sol.gradeGutter = gradeGutter;
    sol.mone = mone
    sol.vindski = vindski

    // Calculate the summary of plates needed
    sol.required = []; // {height, no}
    let plates = sol.plates.map(p => {p.clamped =Math.round(p.height); return {height: p.clamped, no: 1}});
    plates.sort((a, b) => a.height - b.height);
    for(let i = 0; i < plates.length-1; i++) {
      let a = plates[i],
          b = plates[i+1];
      if(a.height == b.height) {
        a.no++;
        plates.splice(i+1, 1)
        i--
      }
    }

		let tp = plates.map(p => p.height)

		// We should also add the map between each piece and
		// the corresponding plate in the required list
		sol.pieces.map( p => {
			p.row = tp.indexOf(sol.plates[p.plate].clamped)	
		})


    sol.required = plates;

		// The add-ons we need to add before spliting the pipes
		let nob = 0
		for(let i = 0; i < pipes.length; i++) {
			nob += Math.ceil(pipes[i]/0.6)
		}
		sol.noSupports = nob

		// Also calculate what we need in terms of
		// pipes
		// Split any pipes > 4000 into pieces
		for(let i = 0; i < pipes.length; i++) {
			for(;pipes[i] > 4;) {
				pipes[i] = pipes[i] -4
				pipes.push(4)
			}
		}
		pipes = pipes.sort((a,b) => b - a)
    sol.pipes =  pipes
    
     return sol
  }

}

// Create a global singleton roof layouter into which we register all the
// defined roof types such that they are available. Each defined roof type
// has all the properties needed such that we can genereate gui and results
// views programatically from the description.
let singleton = new Lay();


// Register all the roof types we have defined
import VRoof from './roofs/vroof.js'
singleton.register("vroof", VRoof)
//import FlatRoof from './roofs/flatroof.js'
//singleton.register("flatroof", FlatRoof)
import TiltedRoof from './roofs/tiltedroof.js'
singleton.register("tiltedroof", TiltedRoof)
import PyramidRoof from './roofs/pyramidroof.js'
singleton.register("pyramidroof", PyramidRoof)
import DutchGableRoof from './roofs/dutchgableroof.js'
singleton.register("dutchgableroof", DutchGableRoof)
import GambrelRoof from './roofs/gambrelroof.js'
singleton.register("gambrelroof", GambrelRoof)
import FlatTopGambrelRoof from './roofs/flattopgambrelroof.js'
singleton.register("flattopgambrelroof", FlatTopGambrelRoof)
import HalfHippedRoof from './roofs/halfhippedroof.js'
singleton.register("halfhippedroof", HalfHippedRoof)
import HippedRoof from './roofs/hippedroof.js'
singleton.register("hippedroof", HippedRoof)
import MansardRoof from './roofs/mansardroof.js'
singleton.register("mansardroof", MansardRoof)
import SawtoothRoof from './roofs/sawtoothroof.js'
singleton.register("sawtoothroof", SawtoothRoof)

// Register all the utstick types we have defined
import GableUtstick from './utsticks/gableutstick.js'
singleton.registerUtstick("gableutstick", GableUtstick);
import FlatUtstick from './utsticks/flatutstick.js'
singleton.registerUtstick("flatutstick", FlatUtstick);
import HalfHippedUtstick from './utsticks/halfhippedutstick.js'
singleton.registerUtstick("halfhippedutstick", HalfHippedUtstick);


window.layout = singleton
module.exports = singleton;



// WEBPACK FOOTER //
// ./Roof.js